import { SatelliteAltTwoTone } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: null,
    estaAutenticado : false,
    userId : null,
    login: {
        logando: false,
        erro: "",
        email: "",
        password: "",
    }
}

export const autenticacaoSlice = createSlice({
    name: "authentication",
    initialState,
    reducers: {
        triggerLogar() { },
        triggerSair() { },
        defineErroLogin : (state, action) => {
            state.login.erro = action.payload
        },
        updateDadosLogin: (state, action) => {
            state.login[action.payload.campo] = action.payload.valor;
        },
        defineLogando: (state, action) => {
            state.login.logando = action.payload;
        },
        defineToken : (state, action) => {
            state.token = action.payload

            if(typeof(action.payload) !== "undefined" && action.payload != null && action.payload.trim().length > 0) {
                var splitted = action.payload.split(".");
                var obj = atob(splitted[1]);
                var obj = JSON.parse(obj);
    
                state.userId = obj["sub"]
                state.estaAutenticado = true
            } else { 
                state.estaAutenticado = false
                state.userId = null
            }
        }
    }
})

export const {
    triggerLogar,
    triggerSair,
    defineErroLogin,
    updateDadosLogin,
    defineLogando,
    defineToken
} = autenticacaoSlice.actions;


export default autenticacaoSlice.reducer;